import React from "react";
import styles from "../../styles/_containers/_automations/templateCard.module.scss";

const TRIGGER_LABELS = {
  appointment_completed: "אחרי שהתור הסתיים",
  customer_inactive: "לקוח לא חזר",
  subscription_expiring: "לפני תפוגת מנוי",
  punch_card_low: "כרטסייה מסתיימת",
  birthday: "יום הולדת",
  customer_created: "לקוח חדש נרשם",
  no_show: "אי-הגעה",
  appointment_cancelled: "תור בוטל",
  low_bookings: "יום חלש ביומן",
  serial_canceller: "מבטל סדרתי",
  review_positive: "ביקורת חיובית",
  review_negative: "ביקורת שלילית",
};

const SparkIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true"><path d="m12 3 1.4 4.1L17.5 8.5l-4.1 1.4L12 14l-1.4-4.1-4.1-1.4 4.1-1.4L12 3Z"/><path d="m18.5 14 .8 2.2 2.2.8-2.2.8-.8 2.2-.8-2.2-2.2-.8 2.2-.8.8-2.2Z"/></svg>
);

export default function TemplateCard({ template, onActivate, activating }) {
  return (
    <article className={styles.card}>
      <div className={styles.templateIcon}><SparkIcon /></div>
      <div className={styles.info}>
        <div className={styles.titleRow}>
          <h3 className={styles.name}>{template.name}</h3>
          <span className={styles.trigger}>{TRIGGER_LABELS[template.triggerType] || template.triggerType}</span>
        </div>
        <p className={styles.description}>{template.description}</p>
      </div>
      <button
        className={styles.activateBtn}
        onClick={() => onActivate(template.id)}
        disabled={activating}
        type="button"
      >
        <span>{activating ? "מפעיל..." : "הפעלת התבנית"}</span>
        <svg viewBox="0 0 20 20" aria-hidden="true"><path d="M10 4v12M4 10h12" /></svg>
      </button>
    </article>
  );
}
